<script setup lang="ts">
import { BaseDialog } from '@/components/Modals/Dialog'
import type { DocumentModel } from '@/types/models/ReplyModel'

type Props = {
    file: DocumentModel
}
defineProps<Props>()
type Emits = {
    (e: 'close'): void
}
defineEmits<Emits>()
</script>

<template>
    <BaseDialog
        :title="$t('ticket.detail.file')"
        :open="!!file"
        @close="$emit('close')"
        hasModalCard
        noFooter>
        <template #content>
            <slot />
        </template>
    </BaseDialog>
</template>
